import React from "react";
import { useTranslation } from "react-i18next";
import { IoMdTrash } from "react-icons/io";
import { MdUnarchive, MdArchive } from "react-icons/md";
import styles from "../NotesPage.module.scss";
const NoteItemAction = ({ onDeleteNote, onArchiveNote, id, archived }) => {
  const { t } = useTranslation('common');
  return (
    <div className={styles["note-item__action"]}>
      <button
        id={id}
        onClick={() => onDeleteNote(id)}
        aria-label={t('notes.delete_aria')}
        className={styles["note-item__delete-button"]}
      >
        <IoMdTrash />
      </button>
      <button
        id={id}
        onClick={() => onArchiveNote(id)}
        aria-label={t('notes.archive_aria')}
        className={styles["note-item__archive-button"]}
      >
        {archived ? <MdUnarchive /> : <MdArchive />}
      </button>
    </div>
  );
};

export default NoteItemAction;
